import { ArrowRight } from 'react-feather';
import Paragraph from '../../Typography/Paragraph';
var CardBig = function (_a) {
    var title = _a.title, description = _a.description, icon = _a.icon, onClick = _a.onClick;
    var handleClick = function () {
        if (onClick) {
            onClick();
        }
    };
    var Icon = icon;
    return (<div className="bg-white flex cursor-pointer items-center gap-4 rounded-lg p-6 shadow-lg transition-all lg:p-8 lg:hover:shadow-2xl" onClick={handleClick}>
      <div className="flex-center h-14 w-14 flex-shrink-0 rounded-full bg-brand-01 md:h-16 md:w-16">
        <Icon size={40} className="fill-white"/>
      </div>
      <div className="flex flex-col gap-2">
        <div className="text-base font-medium md:text-lg md:font-semibold">{title}</div>
        <Paragraph size="xs">{description}</Paragraph>
      </div>
      <ArrowRight className="h-6 w-6 flex-shrink-0 text-brand-01"/>
    </div>);
};
export default CardBig;
